import React from "react";
import "./index.scss";
const Tabs = ({ tabs, activeTab, setActiveTab, type }) => {
  // const [activeTab, setActiveTab] = useState(0)

  const goToTab = (tabIndex) => {
    setActiveTab(tabIndex);
  };
  return (
    <div className="tabs">
      <div className="section-tab">
        {type === "secondary"
          ? tabs.map((tab, index) => (
              <div
                key={index}
                className={
                  activeTab === index
                    ? `secondary-selected`
                    : `secondary-individual`
                }
                onClick={() => goToTab(index)}
              >
                {tab.title}
              </div>
            ))
          : tabs.map((tab, index) => (
              <div
                key={index}
                className={
                  activeTab === index ? `selected-tab` : `individual-tab`
                }
                onClick={() => goToTab(index)}
              >
                {tab.title}
              </div>
            ))}
      </div>
      <div>{tabs[activeTab]?.content}</div>
    </div>
  );
};

export default Tabs;
